module.exports = __webpack_public_path__ + "static/media/bg-5.29123125.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-bg/bg-5.jpg
// module id = 540
// module chunks = 20